(function () {
  'use strict';
  var host = document.querySelector('[data-dac-pdp-picks]');
  if (!host || host.dataset.loaderMounted) return;
  host.dataset.loaderMounted = 'true';
  host.dataset.loading = 'pending';
  var controller, observer;
  var fallback = host.querySelector('a').cloneNode(true);
  function appendAsset(element) {
    return new Promise(function (resolve, reject) {
      function finish(error) {
        controller.signal.removeEventListener('abort', abort);
        element.onload = element.onerror = null;
        if (error) { element.remove(); reject(error); } else resolve();
      }
      function abort() { finish(new Error('Accessory loading stopped')); }
      if (controller.signal.aborted) { abort(); return; }
      controller.signal.addEventListener('abort', abort, { once: true });
      element.onload = function () { finish(); }; element.onerror = function () { finish(new Error('Asset unavailable')); };
      document.head.appendChild(element);
    });
  }
  async function load() {
    if (host.dataset.loading !== 'pending') return;
    host.dataset.loading = 'true';
    if (observer) observer.disconnect();
    controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 12000);
    try {
      var endpoint = new URL(location.href);
      endpoint.searchParams.delete('sections');
      endpoint.searchParams.set('section_id', host.dataset.section);
      if (window.Shopify && Shopify.theme && Shopify.theme.role === 'unpublished') endpoint.searchParams.set('preview_theme_id', Shopify.theme.id);
      var response = await fetch(endpoint.href, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('Accessory section unavailable');
      var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      var section = doc.querySelector('.dac-pdp-recs'), config = doc.querySelector('[data-dac-rec-config]');
      if (!section || !config) throw new Error('Accessory section missing');
      var styles = Array.from(doc.querySelectorAll('link[rel="stylesheet"]'));
      var scripts = Array.from(doc.querySelectorAll('script[src]'));
      function asset(source) {
        var url = new URL(source, location.origin);
        if (url.protocol !== 'https:' || (url.origin !== location.origin && url.hostname !== 'cdn.shopify.com')) throw new Error('Invalid asset');
        return url.href;
      }
      for (var style of styles) {
        var href = asset(style.getAttribute('href'));
        if (!Array.from(document.styleSheets).some(function (sheet) { return sheet.href === href; })) {
          var link = document.createElement('link'); link.rel = 'stylesheet'; link.href = href; await appendAsset(link);
        }
      }
      if (controller.signal.aborted || !host.isConnected) return;
      host.replaceChildren(section, config);
      for (var script of scripts) {
        var src = asset(script.getAttribute('src'));
        var element = document.createElement('script'); element.src = src; await appendAsset(element);
        if (controller.signal.aborted) return;
      }
      if (!window.DACCartRecommendationController) throw new Error('Accessory controller unavailable');
      window.DACCartRecommendationController.mount();
      host.dataset.loading = 'complete';
    } catch (_) {
      host.replaceChildren(fallback);
      host.dataset.loading = 'unavailable';
    } finally { clearTimeout(timeout); }
  }
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) { if (entries.some(function (entry) { return entry.isIntersecting; })) load(); }, { rootMargin: '600px' });
    observer.observe(host);
  } else load();
  window.addEventListener('pageshow', function (event) { if (event.persisted && !window.DACCartOwnership) { host.dataset.loading = 'pending'; load(); } });
  window.addEventListener('pagehide', function () { if (observer) observer.disconnect(); if (controller) controller.abort(); }, { once: true });
}());
